<template>
    <div class="home-activities-wrapper">
        <div class="home-activities">
            <b-container class="home-activities-container">
                <div v-if="isJACareerApp">
                    <p class="text">
                        In this activity, you will follow the steps to design your career plan:
                    </p>
                    <ul>
                        <li class="text">Identify your interests and skills.</li>
                        <li class="text">Explore relevant career options.</li>
                        <li class="text">Narrow down those career options.</li>
                        <li class="text">Plan your career path.</li>
                    </ul>
                </div>
                <div v-if="isJAEntrepreApp">
                     <p class="text">
                        In this activity, you will use proven principles of product design to:
                    </p>
                    <ul>
                        <li class="text">Identify a potential customer problem.</li>
                        <li class="text">Develop and test ideas for a new product or service that could solve that problem.</li>
                    </ul>
                </div>
                <div class="home-activities-buttons">
                    <b-button v-if="isJACareerApp" class="btn-start" tabindex="0" block variant="primary" :to="{name: 'js_start_project'}">Start a New Career Plan</b-button>
                    <b-button v-if="isJAEntrepreApp" class="btn-start" tabindex="0" block variant="primary" :to="{name: 'be_start_project'}">Start a New Project</b-button>
                    <b-button v-if="isJACareerApp" class="btn-return" tabindex="0" block variant="outline-primary" :to="{ name: 'Projects' }">Return to My Plan</b-button>
                    <b-button v-if="isJAEntrepreApp" class="btn-return" tabindex="0" block variant="outline-primary" :to="{ name: 'Projects' }">Return to My Project</b-button>
                    <b-button class="btn-links" tabindex="0" block variant="outline-primary" :to="{ name: 'QuickLinks' }">Quick Links</b-button>
                </div>
            </b-container>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HomeActivities",
    }

</script>

<style scoped lang="stylus">
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .home-activities-wrapper
        background-color color-1

        .home-activities
            padding-bottom 3rem
            padding-top 20px

            &-container
                box-shadow(0px 1px 5px color-shadow)
                padding 25px 20px 30px 25px
                border-radius 25px
                background-color color-blank
                margin-top 0px
                width 90%
                max-width none !important

                .text
                    font font-poppins-regular
                    font-size 16px
                    color color-dark

            &-buttons
                display flex
                align-items center
                margin-top 46px
                flex-direction column
                row-gap 20px

                .btn
                    width 260px
                    margin 0px auto
                    border 2px solid color-green-light
                    padding 12px 0

                .btn-start
                    background-color color-green-light
                    &:hover
                        background-color color-green-dark
                        border 2px solid color-green-dark


                .btn-return
                .btn-links
                    color color-green-light
                    font font-poppins-semibold
                    font-size 16px
                    &:hover
                        background-color color-green-dark !important
                        color color-blank


    @media (min-width: 768px) and (max-width: 1200px)
        .home-activities
            padding-top 30px !important

            &-container
                width 90% !important

                .text
                    font font-poppins-semibold !important
                    font-size 18px !important

            &-buttons
                flex-direction row !important
                column-gap 20px

                .btn-start
                    width 320px !important

                .btn-return
                .btn-links
                    width 250px !important

    @media (min-width: 1200px)
        .home-activities-wrapper
            background-color color-blank !important

            .home-activities
                padding-top 36px !important

                &-container
                    padding 50px 50px 51px 50px !important
                    width 65%

                    .text
                        font font-poppins-semibold !important
                        font-size 22px !important

                &-buttons
                    flex-direction row !important
                    column-gap 20px

                    .btn
                        width 320px !important
                        height 50px !important

</style>
